__turbopack_context__.v({
  "className": "space_grotesk_cab0e887-module__K5CqOq__className",
  "variable": "space_grotesk_cab0e887-module__K5CqOq__variable",
});
